import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CampaignMaintenanceRoutingModule } from './campaign-maintenance-routing.module';
import { CampaignMaintenanceComponent } from './campaign-maintenance.component';
import { CampaignMaintenanceFormComponent } from './campaign-maintenance-form/campaign-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { CampaignMaintenanceFilterComponent } from './campaign-maintenance-filter/campaign-maintenance-filter.component';
import { CampaignMaintenanceDetailComponent } from './campaign-maintenance-detail/campaign-maintenance-detail.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    CampaignMaintenanceRoutingModule
  ],
  declarations: [CampaignMaintenanceComponent, CampaignMaintenanceFormComponent, CampaignMaintenanceFilterComponent, CampaignMaintenanceDetailComponent],
  entryComponents: [CampaignMaintenanceFilterComponent]
})
export class CampaignMaintenanceModule { }